// extracted by mini-css-extract-plugin
export default {"toast__max-width":"toast__max-width_gfV17M41"};